var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccesstick({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 43,
    viewBox: "0 0 42 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 42,
    height: 42,
    rx: 21,
    fill: "#00B885"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.3906 13.4375L17.0625 25.7656L12.5625 21.2188C12.3281 21.0312 11.9531 21.0312 11.7656 21.2188L10.4062 22.5781C10.2188 22.7656 10.2188 23.1406 10.4062 23.375L16.6875 29.6094C16.9219 29.8438 17.25 29.8438 17.4844 29.6094L31.5469 15.5469C31.7344 15.3594 31.7344 14.9844 31.5469 14.75L30.1875 13.4375C30 13.2031 29.625 13.2031 29.3906 13.4375Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccesstick);
export default __webpack_public_path__ + "static/media/successtick.c66606e607d3d72ef6881d2f0f417c4c.svg";
export { ForwardRef as ReactComponent };